import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { tournamentsAPI } from '../utils/api';

const LEVEL_LABELS = { world: '🌍 عالمي', continental: '🌐 قاري', regional: '🗺️ إقليمي', national: '🏳️ وطني', local: '📍 محلي' };
const MEDAL_EMOJI = { gold: '🥇', silver: '🥈', bronze: '🥉', none: '🏅' };

export default function TournamentDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: ['tournament', id],
    queryFn: () => tournamentsAPI.getOne(id).then(r => r.data.data)
  });

  if (isLoading) return <div className="loading"><div className="spinner" /></div>;
  if (!data) return null;

  const t = data;

  return (
    <div>
      <div className="topbar">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button className="btn btn-secondary btn-sm" onClick={() => navigate(-1)}>← رجوع</button>
          <div>
            <div className="topbar-title">{t.name_ar || t.name}</div>
            {t.name_ar && <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{t.name}</div>}
          </div>
        </div>
        <span className={`level-badge level-${t.level}`}>{LEVEL_LABELS[t.level]}</span>
      </div>

      <div className="page-content">
        {/* Info card */}
        <div className="card" style={{ marginBottom: 24 }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px,1fr))', gap: 20 }}>
            <div>
              <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 4 }}>الرياضة</div>
              <div style={{ fontWeight: 600 }}>{t.sport_icon} {t.sport_name_ar || t.sport_name}</div>
            </div>
            <div>
              <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 4 }}>التاريخ</div>
              <div style={{ fontWeight: 600 }}>{t.start_date?.slice(0,10)}{t.end_date ? ` → ${t.end_date.slice(0,10)}` : ''}</div>
            </div>
            {t.location && (
              <div>
                <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 4 }}>الموقع</div>
                <div style={{ fontWeight: 600 }}>📍 {t.location}</div>
              </div>
            )}
            {t.organizer && (
              <div>
                <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 4 }}>المنظم</div>
                <div style={{ fontWeight: 600 }}>{t.organizer}</div>
              </div>
            )}
            <div>
              <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 4 }}>المشاركون</div>
              <div style={{ fontWeight: 600 }}>{t.results?.length || 0} لاعب</div>
            </div>
          </div>
        </div>

        {/* Results table */}
        <div className="card" style={{ padding: 0 }}>
          <div style={{ padding: '20px 20px 0' }}>
            <h2 style={{ fontSize: 16, fontWeight: 700 }}>🏆 نتائج البطولة</h2>
          </div>
          <div className="table-wrap">
            {!t.results?.length ? (
              <div className="empty"><div className="empty-icon">📋</div><p>لا توجد نتائج مسجلة</p></div>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>المركز</th>
                    <th>اللاعب</th>
                    <th>الدولة</th>
                    <th>النتيجة</th>
                    <th>النقاط</th>
                  </tr>
                </thead>
                <tbody>
                  {t.results.map(r => (
                    <tr key={r.id} onClick={() => navigate(`/players/${r.player_id}`)} style={{ cursor: 'pointer' }}>
                      <td>
                        <div style={{ fontWeight: 700, fontSize: 20 }}>{MEDAL_EMOJI[r.medal_type] || r.placement}</div>
                      </td>
                      <td>
                        <div className="player-cell">
                          <div className="player-avatar">{(r.full_name || '').charAt(0)}</div>
                          <div>
                            <div style={{ fontWeight: 600 }}>{r.full_name_ar || r.full_name}</div>
                          </div>
                        </div>
                      </td>
                      <td>{r.flag_emoji} {r.country_name}</td>
                      <td><span className={`medal medal-${r.medal_type}`}>{r.medal_type === 'none' ? 'مشاركة' : r.medal_type === 'gold' ? 'ذهبية' : r.medal_type === 'silver' ? 'فضية' : 'برونزية'}</span></td>
                      <td><span className="points-value">+{Math.round(r.points_earned)}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
